/* Shopping dropdown only. Native Shopify drawers/commerce remain in control. */
(() => {
  function init() {
    document.querySelectorAll('[data-bridge-dropdown]').forEach(details => {
      if (details.dataset.bridgeReady) return;
      details.dataset.bridgeReady = 'true';
      const trigger = details.querySelector('summary');
      let closeTimer;
      let openedOnHover = false;
      const close = (focus = false) => {
        clearTimeout(closeTimer);
        details.open = false;
        openedOnHover = false;
        trigger.setAttribute('aria-expanded', 'false');
        if (focus) trigger.focus();
      };
      details.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(details.open)));
      details.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && matchMedia('(hover:hover)').matches) {
          clearTimeout(closeTimer);
          if (!details.open) openedOnHover = true;
          details.open = true;
        }
      });
      details.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') closeTimer = setTimeout(() => close(), 180);
      });
      trigger.addEventListener('click', event => {
        if (openedOnHover) {
          event.preventDefault();
          openedOnHover = false;
          details.open = true;
        }
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          close(true);
        }
      });
      details.addEventListener('focusout', event => {
        if (!details.contains(event.relatedTarget)) close();
      });
      document.addEventListener('click', event => {
        if (details.open && !details.contains(event.target)) close();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
